import { createSelector } from 'reselect';
import mapValues from 'lodash/mapValues';
import { getAllWidgets, minimalDashboard } from '../dashboards/selectors';

const dashboardIds = (state) => state.defaultDashboards.ids;

export const getDefaultDashboardsById = (state) => state.entities.dashboards;

export const getActiveDefaultDashboardIsLoading = (state) => state.defaultDashboards.isLoading;

export const getActiveDefaultDashboardId = (state) => state.defaultDashboards.activeDashboardId;

export const getActiveDefaultDashboard = createSelector(
  [getDefaultDashboardsById, getActiveDefaultDashboardId],
  (dashboards, id) => (dashboards[id] ? dashboards[id] : minimalDashboard),
);


export const getAllDefaultDashboards = createSelector(
  [getDefaultDashboardsById, dashboardIds],
  (dashboards, ids) => ids.map((id) => dashboards[id]),
);


export const getActiveDefaultDashboardToolboxWidgets = createSelector(
  [getAllWidgets, getActiveDefaultDashboard],
  (widgets, dashboard) => mapValues(
    dashboard.layout,
    (activeWidgets) => {
      const activeWidgetIds = activeWidgets.map((w) => w.i);
      return widgets.filter((w) => !activeWidgetIds.includes(w.id))
        .map((widget) => ({
          w: widget.width,
          h: widget.height,
          i: widget.id,
          x: 0,
          y: 0,
          static: false,
        })) || [];
    },
  ),
);


export const getDefaultDashboardsSelectOptions = createSelector(
  [getAllDefaultDashboards],
  (dashboards) => dashboards.map((dashboard) => ({
    value: dashboard.id,
    label: dashboard.name ? dashboard.name : '- name missing -',
  })),
);
